export default __webpack_public_path__ + "static/media/39.8716956f.jpg";